import request from "../utils/request"


//用户登录
export const userLogin = (params) => {
    return request.post("wealth-portal/user/login", params)
}

//用户注册
export const userRegister = (params) => {
    return request.post("wealth-portal/user/register", params)
}

//用户详情
export const getUserInfo = () => {
    return request.post("wealth-portal/user/getRealtime")
}

//获取通道列表
export const getChannelList = () => {
    return request.post("wealth-admin/payChannel/query", {})
}

//充值下单
export const payOrder = (channelId, amount) => {
    return request.post("wealth-portal/payOrder/save", {
        channelId: channelId,
        amount: amount
    })
}

//分享码
export const getRefCode = () => {
    return request.post("wealth-portal/user/getRef", {})
}

//验证码
export const getSmsCode = (phone) => {
    let params = phone ? { 'phone': phone } : {}
    return request.post("wealth-portal/user/getSms", params)
}

//获取银行卡
export const getBank = () => {
    return request.post("wealth-admin/bank/getMy", {})
}

//绑定银行卡
export const bindBank = (params) => {
    return request.post("wealth-admin/bank/save", params)
}

//忘记密码
export const findPassword = (params) => {
    return request.post("wealth-portal/user/findPwd", params)
}

//修改密码
export const saveUser = (params) => {
    return request.post("wealth-portal/user/save", params)
}

//修改支付密码
export const modifyPayPassword = (params) => {
    return request.post("wealth-portal/user/savePayPwd", params)
}

//修改头像
export const changePassword = (params) => {
    return request.post("wealth-portal/user/savePwd", params)
}

//提现
export const withdraw = (params) => {
    return request.post("wealth-portal/cashOutApply/save", params)
}

//付款记录
export const getRechargeRecord = (params) => {
    return request.post("wealth-portal/payOrder/queryMy", params)
}

//取款记录
export const getWithdrawRecord = (params) => {
    return request.post("wealth-portal/cashOutApply/queryMy", params)
}

//工资记录
export const getSalaryRecord = (params) => {
    return request.post("wealth-admin/salary/getMy", params)
}

//分享记录
export const getShareRecord = (params) => {
    return request.post("wealth-portal/shareRecord/getMy", params)
}

//发现页
export const getFindHtml = () => {
    return request.post("wealth-admin/find/html", {})
}

//团队数据
export const getTeamData = (params) => {
    return request.post("wealth-portal/user/getTeam", params)
}

//工资入账记录
export const getSalaryCreatedRecord = (params) => {
    return request.post("wealth-portal/salaryChange/created", params)
}

//工资取现记录
export const getSalaryWithdrawRecord = (params) => {
    return request.post("wealth-portal/cashOutApply/salary", params)
}

//交易入账记录
export const getTradeCreatedRecord = (params) => {
    return request.post("wealth-portal/balanceChange/created", params)
}

//交易取现记录
export const getTradeWithdrawRecord = (params) => {
    return request.post("wealth-portal/cashOutApply/balance", params)
}

//下单
export const tradeOrder = (params) => {
    return request.post("wealth-portal/tradeOrder/save", params)
}

//交易历史
export const getTradeHistory = (params) => {
    return request.post("wealth-portal/tradeOrder/queryMy", params)
}

//账户结算
export const getAccountRecord = (params) => {
    return request.post("wealth-portal/balanceChange/queryMyBill", params)
}

//获取聊天房间
export const getChatRooms = (params) => {
    return request.post("wealth-portal/talk/chat_rooms", params)
}

//获取聊天消息
export const getChatMessages = (params) => {
    return request.post("wealth-portal/talk/message", params)
}

export const uploadChatFile = async (file) => {
    return await request.post("wealth-portal/filebyte/upload", file.blob, {
        headers: {
            'Content-Type': 'application/json',
            param: JSON.stringify({
                extension: file.extension,
                type: file.type,
                size: file.size,
                name: encodeURIComponent(file.name),
            }),
        },
    })
}

//上传头像
export const uploadFile = (params) => {
    return request.post("wealth-portal/image/upload", params, {
        transformRequest: (data, headers) => {
            // 删除手动设置的 Content-Type，让 Axios 自动处理
            delete headers['Content-Type'];
            return data;
        },
    })
}

//公告消息
export const getNoticeList = (params) => {
    return request.post("wealth-admin/notice/mobileQuery", params)
}

//圈子消息
export const getCircleList = (params) => {
    return request.post("wealth-admin/message/getCircle", params)
}


//货币列表
export const getCurrencyList = () => {
    return request.post("wealth-portal/market/findCurrencyList")
}

//K线数据
export const getKlineData = (coinName, time) => {
    return request.post("wealth-portal/market/findMarketByTradePair", {
        pageNo: 1, pageSize: 300, tradePair: coinName, time: time
    })
}

//翻译
export const translate = (text, targetLang) => {
    return request.post("wealth-portal/translate", {
        targetLanguageCode: targetLang,
        text: text
    })
}

//公共字典
export const queryCommonDict = () => {
    return request.post("wealth-admin/dict/mobileQueryCommon", {})
}

//字典
export const queryDict = (params) => {
    return request.post("wealth-admin/dict/mobileQuery", params)
}

//首页弹窗
export const getHomeDialogMess = () => {
    return request.post("wealth-admin/message/getPopup", {})
}

//获取最大可下单金额
export const getAvailableAmount = () => {
    return request.post("wealth-portal/tradeOrder/getAvailableAmount", {})
}

//获取银行列表
export const getBankList = () => {
    return request.post("wealth-admin/dict/getByType/bank_of_tanzania", {})
}

//获取邀请任务提示
export const getInviteTaskTip = () => {
    return request.post("wealth-portal/user/inviteTaskTip", {})
}